import classNames from 'classnames';
import React from 'react';
import { Card, Form } from 'react-bootstrap';

const ADAdvancedSettings = () => {
  const advanceSettingsData = [
    { id: 1, title: 'Cover $0.00 Transaction Fees', value: '1', checked: true },
    { id: 2, title: 'Gift Aid Eligible ', value: '2', checked: false },
    { id: 3, title: 'Given in honor or In memory', value: '3', checked: false },
    { id: 4, title: 'Anonymous Donation', value: '4', checked: true },
    { id: 5, title: 'Keep Donor Updated ', value: '5', checked: true }
  ];
  return (
    <Card className="mb-3">
      <Card.Header className="pb-0">
        <Card.Title className="fw-medium">Advanced Settings</Card.Title>
      </Card.Header>
      <Card.Body>
        {advanceSettingsData?.map((setting, index) => (
          <div
            key={setting.id}
            className={classNames('p-3 pb-2 border rounded-3', {
              'mb-3': index !== advanceSettingsData?.length - 1
            })}
          >
            <Form.Check
              type="checkbox"
              id={setting.value}
              label={setting.title}
              defaultChecked={setting.checked}
              className="mb-0"
            />
          </div>
        ))}
      </Card.Body>
    </Card>
  );
};

export default ADAdvancedSettings;
